<template>
  <div>
    <a-spin :spinning="confirmLoading">
      <a-card title="基本信息" :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form :form="form" layout="inline">
            <a-row :gutter="16">
              <a-col :xl="6" :lg="9" :md="16" :sm="24">
                <a-form-item
                  label="考勤小组">
                  <a-select
                    @select="selectChange"
                    style="width: 85%"
                    :defaultValue="attendGroupList[2]"
                    :filterOption="filterOption"
                    showSearch
                    placeholder="请选择"
                    v-model="queryParam.groupId"
                    :options="attendGroupList">
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="8" :md="8" :sm="24">
                <a-form-item label="工人类别">
                  <a-select
                    showSearch
                    placeholder="请选择"
                    :filterOption="filterOption"
                    v-model="queryParam.typeId"
                    :options="workerList">
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="12" :md="24" :sm="24">
                <a-form-item
                  label="时间">
                  <a-date-picker
                    style="width: 85%"
                    @change="onDateChange"
                    :allowClear="false"
                  />
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="12" :md="24" :sm="24">
                <a-button @click="getAttendanceAndTheadRes" type="primary">查询</a-button>
              </a-col>
            </a-row>
          </a-form>
        </div>
      </a-card>
      <a-card
        :title="'日报信息 ' + (dailyData.length > 0 ? '- 累计 '+ sumHours(dailyData) + ' h':'- 累计 0 h') "
        :bordered="false"
        style="margin-top: 20px;">
        <a-table
          ref="table"
          :data-source="dailyData"
          :columns="columns"
          :pagination="false"
        >
        </a-table>
      </a-card>
      <a-card :title="'考勤上报 ' + sumSubmit" :bordered="false" style="margin-top: 20px;">
        <a-form :form="form" layout="inline">
          <a-row :gutter="16">
            <a-col
              :xl="4"
              :lg="9"
              :md="16"
              :sm="24"
              v-for="item in attendReport"
              :key="item.workerId">
              <a-form-item
                :label="item.name">
                <a-input-number
                  :min="0"
                  :max="30"
                  :precision="2"
                  :disabled="queryParam.groupId !== item.groupId "
                  v-model="item.workHour"></a-input-number>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-card>
      <footer-tool-bar style="z-index: 11;">
        <a-button
          :disabled="submitDisabled"
          type="primary"
          @click="submitAttendance"
          :loading="buttonLoading"
          v-action="'attend:editDaily:submit'"
        >提交</a-button>
      </footer-tool-bar>
    </a-spin>
  </div>
</template>

<script>
import EditableCell from './component/EditableCell'
import EmptyImage from './component/EmptyImage'
import FooterToolBar from '@/components/FooterToolbar/FooterToolBar'
import { newListHour, putObj } from '@api/attend/attendDaily'
import { getGroupAndWorkerType } from '@api/common/AttendGroup'
import { getDailyWorkerHours } from '@api/statement/workerCost'

export default {
  name: 'EditDaily',
  components: {
    EditableCell,
    EmptyImage,
    FooterToolBar
  },
  data () {
    return {
      totalHours: 0,
      sumSubmit: '累计 0 h',
      attendReport: [], // 考勤上报列表
      dailyData: [], // 日报中上报工时数据
      workerList: [], // 工人类别列表
      attendGroupList: [], // 考勤小组数据
      confirmLoading: false, // 是否显示loading遮罩层
      buttonLoading: false,
      form: this.$form.createForm(this),
      queryParam: {
        groupId: '', // 考勤小组id，默认选择列表中第一个考勤小组
        typeId: undefined, // 工人类别
        attendDate: ''
      },
      submitDisabled: true, // 提交按钮是否禁用
      columns: [
        {
          title: '序号',
          width: '70px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '项目名称',
          dataIndex: 'projectName'
        },
        {
          title: '考勤小组',
          dataIndex: 'groupName'
        },
        {
          title: '工人类别',
          dataIndex: 'typeName'
        },
        {
          title: '用工数量',
          dataIndex: 'number'
        },
        {
          title: '合计工时(h)',
          dataIndex: 'totalHour'
        }
      ]

    }
  },
  mounted () {
    this.init()
  },
  methods: {
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    sumHours (attendReport) {
      let sum = 0
      attendReport.forEach(da => {
        sum += isNaN(da.totalHour) ? 0 : da.totalHour
      })
      this.totalHours = sum.toFixed(2)
      return this.totalHours
    },
    /*
    * 页面初始化时获取考勤小组列表数据
    * */
    init () {
      getGroupAndWorkerType().then(res => {
        this.attendGroupList = res.data
        // 修改原因：不同权限对应的下拉选择框的第一个数据不一样，所以此处动态取值
        this.queryParam.groupId = res.data[0].value
        this.queryParam.typeId = res.data[0].child[0].value
        this.getAttendanceAndTheadRes()
      })
      // attendGroupList().then(res => {
      //   this.attendGroupList = res.data
      //   // 修改原因：不同权限对应的下拉选择框的第一个数据不一样，所以此处动态取值
      //   this.queryParam.groupId = res.data[0].value
      //   this.getAttendanceAndTheadRes()
      // })
      // // 获取工人列表
      // dropSxWorkerTypeList().then(res => {
      //   this.workerList = res.data
      //   this.queryParam.typeId = res.data[0].value
      // })
      this.getListHours()
    },
    /**
     * 日期处理
     * */
    onDateChange (date) {
      this.queryParam.attendDate = date.format('YYYY-MM-DD')
    },
    // 获取日报的工人上报数据
    getAttendanceAndTheadRes () {
      this.getDailyWorkerHours()
      this.getListHours()
    },
    // 选中考勤小组时触发
    selectChange (e) {
      if (e != null) {
        this.queryParam.groupId = e
      }
      // this.getAttendanceAndTheadRes()
    },
    /**
     * 查询日报工时
     */
    getDailyWorkerHours () {
      getDailyWorkerHours(this.queryParam).then(res => {
        this.dailyData = res.data
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    // 获取考勤上报列表数据
    getListHours () {
      this.confirmLoading = true
      newListHour(this.queryParam).then(res => {
        this.attendReport = res.data
      }).catch(err => {
        this.$message.error(err.msg)
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    // 最终提交
    submitAttendance () {
      this.confirmLoading = true
      this.buttonLoading = true
      putObj({
        groupId: this.queryParam.groupId,
        typeId: this.queryParam.typeId,
        attendDate: this.queryParam.attendDate,
        workHourList: this.attendReport
      }).then(res => {
        this.$message.success('操作成功')
      }).catch(err => {
        this.$message.error(err.msg)
      }).finally(() => {
        this.confirmLoading = false
        this.buttonLoading = false
      })
    }
  },
  watch: {
    'attendReport': {
      deep: true,
      immediate: true,
      handler: function (newData) {
        let sum = 0
        newData.forEach(da => {
          if (da.groupId === this.queryParam.groupId) {
            sum += isNaN(da.workHour) ? 0 : da.workHour
          }
        })
        this.sumSubmit = (sum > 0 ? '- 累计 ' + sum.toFixed(2) + ' h' : '- 累计 0 h')
        // 控制是否可以提交数据  全0可以提交
        this.submitDisabled = !(sum.toFixed(2) === this.totalHours || this.totalHours === 0 && sum.toFixed(2) === '0.00')
      }
    },
    'queryParam.groupId': {
      deep: true,
      immediate: true,
      handler: function (newData) {
        const item = this.attendGroupList.filter(item => item.value === newData)[0]
        if (item && item.child[0]) {
          this.queryParam.typeId = item.child[0].value
          this.workerList = item.child
        } else {
          this.queryParam.typeId = ''
          this.workerList = []
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .scrollBox{
    overflow: hidden;
    overflow-x: auto;
  }
  input{
    border: none;
    text-align: center;
  }
  button{
    margin-left: 20px;
  }
</style>
